import { ChevronDownIcon } from '@heroicons/react/solid';
import { FC, useState } from 'react';
import { Arrow } from 'react-laag';
import { YearOfExperiencePattern } from '../../InputPatterns';
import { InputProps } from './interface';

const ExperienceList = [
  { value: '', title: 'Select Experience' },
  { value: 'student', title: 'Student' },
  { value: 'fresher', title: 'Fresher' },
  { value: '1 to 3 Years', title: '1 to 3 Years' },
  { value: '3 to 7 Years', title: '3 to 7 Years' },
  { value: '7+ Years', title: '7+ Years' },
];
const SelectTag: FC<InputProps> = ({ register, errors, fullWidth, asterisk }) => {
  const storedValues = localStorage.getItem('formData');
  const user_experience = JSON.parse(storedValues)?.user_experience;
  const [open, setOpen] = useState(false);

  // function to open/close dropdown
  const changeOpen = () => {
    setOpen(!open);
  };

  return (
    <div onClick={changeOpen} className={`relative md:mb-8 mb-[25px] w-full group`}>
      {/* Label & input */}
      <select
        defaultValue={user_experience}
        {...register('user_experience', YearOfExperiencePattern)}
        className={`h-10 border px-3 w-full bg-white rounded cursor-pointer border-gray-300 focus-visible:outline-none focus-visible:outline-0 appearance-none  ${
          errors?.user_experience && 'border-red-500 focus-visible:border-red-500 focus-within:border-red-500'
        }`}
      >
        {ExperienceList.map((ele, index) => {
          return (
            <option defaultValue={user_experience} className="px-3 py-2" value={ele.value} key={index}>
              {ele.title}
            </option>
          );
        })}
      </select>
      {errors.user_experience ? (
        <label
          className={`capitalize absolute left-2 -top-[9px] text-red-500 text-xs leading-[18px] transition-all peer-placeholder-shown:text-xs peer-placeholder-shown:leading-[18px]  peer-placeholder-shown:text-red-500 peer-placeholder-shown:-top-[9px] peer-focus:-top-[9px] peer-focus:text-red-500 peer-focus:text-xs pointer-events-none peer-focus:px-1 bg-white px-1 peer-focus:leading-[18px]`}
        >
          Year of Experience*
        </label>
      ) : (
        <label
          className={`capitalize absolute left-2 -top-[9px] text-[#777777] text-xs leading-[18px] transition-all peer-placeholder-shown:text-[13px] peer-placeholder-shown:leading-5 peer-placeholder-shown:text-[#777777] peer-placeholder-shown:top-[10px] peer-focus:-top-[9px] peer-focus:text-[#777777] peer-focus:text-xs peer-focus:leading-[18px] pointer-events-none peer-focus:px-1 bg-white px-1`}
        >
          Years of Experience*
        </label>
      )}

      {/* Error Message Container */}
      <p
        className={`${
          errors?.user_experience?.type ? 'visible' : 'invisible'
        } text-red-500 md:text-[11px] text-[9px] leading-4 mt-[2px] absolute capitalize`}
      >
        {errors?.user_experience?.type === 'required' ? 'This field is required' : 'Something went wrong'}
      </p>
      <div className='absolute right-3 top-3'>
        <ChevronDownIcon className="w-5 text-[#181822]" />
      </div>
    </div>
  );
};

export default SelectTag;
